import { BoxCard } from "./common/BoxCard";
import { AssetTypeCard } from "./common/AssetTypeCard";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { getAssetTypes } from "../services/bags";
import { getAssetTypeTitle } from "../utils/assetRoutes";

export const Content = (props) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isDashboard = Boolean(props.assetTypes);
  const [assetTypes, setAssetTypes] = useState([]);
  const [assetTypesLoaded, setAssetTypesLoaded] = useState(isDashboard);
  const [isDark, setIsDark] = useState(
    () =>
      typeof window !== "undefined" && document.body.classList.contains("dark")
  );

  useEffect(() => {
    const checkDark = () => setIsDark(document.body.classList.contains("dark"));
    checkDark();
    const observer = new MutationObserver(() => {
      checkDark();
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (isDashboard) return;

    let cancelled = false;

    const fetchAssetTypes = async () => {
      try {
        const res = await getAssetTypes();
        if (cancelled) return;
        setAssetTypes(res?.data?.data ?? []);
      } catch {
        if (!cancelled) setAssetTypes([]);
      } finally {
        if (!cancelled) setAssetTypesLoaded(true);
      }
    };

    fetchAssetTypes();

    return () => {
      cancelled = true;
    };
  }, [isDashboard]);

  const pageTitle = useMemo(() => {
    if (isDashboard) return props.pageName;
    if (!assetTypesLoaded) return null;

    return getAssetTypeTitle(assetTypes, {
      type: searchParams.get("type"),
      pathname: location.pathname,
    });
  }, [
    assetTypes,
    assetTypesLoaded,
    isDashboard,
    location.pathname,
    props.pageName,
    searchParams,
  ]);

  return (
    <div className="basis-full p-6">
      {pageTitle ? (
        <div className="mb-6">
          <h1
            className="
              relative inline-block text-3xl font-bold mb-6 
              text-[#0010c6] dark:text-white
              after:content-[''] after:block after:w-full after:h-[4px] 
              after:bg-[#0010c6] after:mt-[10px] dark:after:bg-[#ffffff]
            "
          >
            {pageTitle}
          </h1>
        </div>
      ) : null}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
        {props.assetTypes
          ? props.assetTypes.map((item) => (
              <AssetTypeCard key={item.slug} item={item} isDark={isDark} />
            ))
          : props.boxes?.map((item) => {
              if (item.pivot.status === -1) return null;

              return (
                <BoxCard
                  key={item.name}
                  title={item.name}
                  item={item}
                  id={props.id}
                  itemId={item.id}
                  pageName={pageTitle ?? ""}
                  isDark={isDark}
                />
              );
            })}
      </div>
    </div>
  );
};
